// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","rowSpacing":"Footer_rowSpacing__23OWW","link":"Footer_link__9_ojg"};